import { UserRoleEnum } from '../../common/user/enums/user-role.enum';
import { IAccessToken } from '../../store/user/selectors';
import { isExpiredTokenHelper } from './is-expired-token.helper';

export const isValidTokenByRoleHelper = (
  role: UserRoleEnum,
  accessToken?: IAccessToken
): boolean => {
  return (
    !!accessToken &&
    !isExpiredTokenHelper(accessToken?.exp) &&
    !!accessToken?.roles?.length &&
    accessToken.roles.includes(role)
  );
};
